import api from './api';

const read = async (path, { signal, authenticated = false, params } = {}) => {
  const response = await api.get(path, {
    signal,
    timeout: 15000,
    params,
    requireAuth: authenticated,
    suppressGlobalError: true,
  });
  return response.data.data;
};
export const discoveryApi = {
  home: (signal) => read('/home', { signal }),
  homeMonthlyReleases: (signal) =>
    read('/albums/new-releases', {
      signal,
      params: {
        type: 'albums',
        sort: 'popular',
        page: 1,
        size: 50,
        period: 'month',
        region: 'all',
      },
    }),
  recentReviews: (signal) =>
    read('/albums/recent-reviews', {
      signal,
      params: { sort: 'latest', page: 1, size: 15, period: 'all', region: 'all', type: 'all' },
    }),
  albums: ({
    authenticated,
    signal,
    albumSize = 4,
    includeSupportingContent = true,
    includeTracks = includeSupportingContent,
    retain = [],
  }) =>
    read('/search/discovery', {
      authenticated,
      signal,
      params: {
        albumSize: Math.max(1, Math.min(36, albumSize)),
        includeSupportingContent,
        includeTracks,
        retain: retain.filter(Number.isSafeInteger).slice(0, 12).join(','),
      },
    }),
  reviewerCandidates: (signal, size = 100) =>
    read('/albums/recent-reviews', {
      signal,
      params: { sort: 'latest', page: 1, size, period: 'all', region: 'all', type: 'all' },
    }),
  members: (signal) =>
    read('/users/discover', { authenticated: true, signal, params: { page: 1, size: 12 } }),
  following: (nickname, signal) =>
    read(`/users/${encodeURIComponent(nickname)}/following`, { authenticated: true, signal }),
  memberReviews: (nickname, authenticated, signal) =>
    read(`/users/${encodeURIComponent(nickname)}/reviews`, { authenticated, signal }),
  album: (item, signal) =>
    read(
      item.albumSlug || item.slug
        ? `/albums/by-slug/${encodeURIComponent(item.albumSlug || item.slug)}`
        : `/albums/${encodeURIComponent(item.albumId || item.id)}`,
      { signal },
    ),
  recordEvents: async (events, signal) => {
    if (!events.length) return;
    await api.postAuth(
      '/search/discovery/events/batch',
      { events },
      { signal, timeout: 15000, suppressGlobalError: true },
    );
  },
  feedback: (kind, id, signal) =>
    read(`/search/discovery/${kind}/${id}/feedback`, { authenticated: true, signal }),
  clearFeedback: (kind, id, signal) =>
    api.deleteAuth(`/search/discovery/${kind}/${id}/feedback`, {
      signal,
      timeout: 15000,
      suppressGlobalError: true,
    }),
  timeline: (params, signal) => read('/albums/timeline', { params, signal }),
};
